// Parses an order.userInputAddress value. Historically this field is a String,
// but some properties (e.g. property id 6626fba3974819b390186d9d) have agents
// stuffing a JSON object into it to carry structured delivery details
// (propertyManager, line1, city, etc.). This helper returns a normalized
// shape the UI can render safely, regardless of whether the backing value is
// a plain string or a JSON-encoded object.
export default function parseUserInputAddress(value) {
  if (!value || typeof value !== "string") return { raw: value || "", parsed: null };
  const trimmed = value.trim();
  if (!(trimmed.startsWith("{") && trimmed.endsWith("}"))) {
    return { raw: value, parsed: null };
  }
  try {
    const obj = JSON.parse(trimmed);
    if (obj && typeof obj === "object") {
      return {
        raw: value,
        parsed: {
          propertyManager: obj.propertyManager || "",
          line1: obj.line1 || "",
          line2: obj.line2 || "",
          city: obj.city || "",
          state: obj.state || "",
          zipCode: obj.zipCode || obj.zip || "",
          entryInstructions: obj.entryInstructions || "",
        },
      };
    }
  } catch (_e) {
    // fall through
  }
  return { raw: value, parsed: null };
}

// Single-line address summary used in headers and tooltips.
export function formatParsedAddress(parsed) {
  if (!parsed) return "";
  const parts = [parsed.line1, parsed.line2, parsed.city, parsed.state, parsed.zipCode]
    .map((p) => (p || "").trim())
    .filter(Boolean);
  return parts.join(", ");
}
